module.exports = __webpack_public_path__ + "static/media/fasmedo_logo3_white.cbe19c56.png";